
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Building } from "lucide-react";
import { IconListItem } from "@/components/ui/icon-list-item";

interface FacilitiesSectionProps {
  facilities: string[];
}

export function FacilitiesSection({ facilities }: FacilitiesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Facilities</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {facilities?.map((facility) => (
            <IconListItem key={facility} icon={Building} text={facility} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
